import { createAxiosInstance } from './createAxiosInstance';
import { getApiUrlFromGlobal } from './getApiUrlFromGlobal';
import { createi18nStaticTranslator } from './createi18nStaticTranslator';
import { createHostLinkGetter } from './createHostLinkGetter';
import { getApiUrlFromEndpoint } from './getApiUrlFromEndpoint';

export default {
  createAxiosInstance,
  getApiUrlFromGlobal,
  createi18nStaticTranslator,
  createHostLinkGetter,
  getApiUrlFromEndpoint
};
